<!-- =========================================================================================
  File Name: UserEditTabInformation.vue
  Description: User Edit Information Tab content
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->
<style lang="scss">
.input-field {
  width: 100%;
}
.ql-editor.ql-blank {
  min-height: 150px;
}
.track-wrapper {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-top: 9px;
}
.track-select {
  width: 85%;
  margin-right: 15px;
}
.input-track-name {
  width: 75%;
  margin-right: 15px;
}
.add-track-inner-section {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.rqrd {
  color: #f00;
}
.meeting-setting-popup .con-vs-tabs {overflow-y: auto; overflow-x: hidden;}
.meeting-setting-popup .con-vs-tabs .con-slot-tabs {overflow-y: auto; overflow-x: hidden;}
</style>
<template>
  <div id="user-edit-tab-info">
    <!-- Content Row -->
    <div class="vx-row">

      <div class="vx-col md:w-1/2 w-full mt-5"> 
        <label>Start Date</label>
        <flat-pickr :config="configdateTimePickerStart" name="Start Date" v-model="data_local.StartDate" v-validate="'required'" placeholder="Start Date" class="time-pkr"/>
        <span class="text-danger text-sm"  v-show="errors.has('Start Date')">{{ errors.first('Start Date') }}</span>
      </div>
      <div class="vx-col md:w-1/2 w-full mt-5">
        <label>End Date</label>
        <flat-pickr :config="configdateTimePickerEnd" name="End Date" v-model="data_local.EndDate" v-validate="'required'" placeholder="End Date" class="time-pkr"/>
        <span class="text-danger text-sm"  v-show="errors.has('End Date')">{{ errors.first('End Date') }}</span>
      </div>



      <div class="vx-col md:w-1/2 w-full mt-4">
        <label>
          Availability From Time (Min)
          <span class="rqrd">*</span>
        </label>
        <vs-input
          class="w-full mt-3"
          name="AvailabilityFromTime"
          v-model="data_local.AvailabilityFromTime"
          v-validate="'required'"
        />
        <span
          class="text-danger text-sm"
          v-show="errors.has('AvailabilityFromTime')"
        >{{ errors.first('AvailabilityFromTime') }}</span>
      </div>
      <div class="vx-col md:w-1/2 w-full mt-4">
        <label>
          Availability To Time (Min)
          <span class="rqrd">*</span>
        </label>
        <vs-input
          class="w-full mt-3"
          type="number"
          name="AvailabilityToTime"          
          v-model="data_local.AvailabilityToTime"
          v-validate="'required'"
        />
        <span
          class="text-danger text-sm"
          v-show="errors.has('AvailabilityToTime')"
        >{{ errors.first('AvailabilityToTime') }}</span>
      </div>

      <div class="vx-col md:w-1/2 w-full mt-4">
        <label>
          Slot (Min)
          <span class="rqrd">*</span>
        </label>
        <vs-input
          class="w-full mt-3"
          type="number"
          name="Slot"          
          v-model="data_local.Slot"
          v-validate="'required'"
        />
        <span
          class="text-danger text-sm"
          v-show="errors.has('Slot')"
        >{{ errors.first('Slot') }}</span>
      </div>
      

      <div class="vx-col md:w-1/2 w-full mt-5">
          <label>Button Label</label>
          <vs-input class="inputx time-pkr" placeholder="Button Label" v-model="data_local.ButtonLabel" />
      </div>

      <div class="vx-col md:w-1/2 w-full mt-5">
          <label>Location</label>
          <vs-input class="inputx time-pkr" placeholder="Location" v-model="data_local.Location" />
      </div>

      <div class="vx-col md:w-1/2 w-full mt-5">
          <label>Notification Message</label>
          <vs-input class="inputx time-pkr" placeholder="Message" v-model="data_local.NotificationMessage[0].Message" />
      </div>

      <div class="vx-col md:w-1/2 w-full mt-5">
          <label>Notification Name</label>
          <vs-input class="inputx time-pkr" placeholder="Name" v-model="data_local.NotificationMessage[0].Name" />
      </div>

      <div class="vx-col md:w-1/2 w-full mt-5">
          <label>Notification Notify Before (Min)</label>
          <vs-input class="inputx time-pkr" placeholder="Notify Before" v-model="data_local.NotificationMessage[0].NotifyBefore" />
      </div>
     
    </div>

    <!-- Save & Reset Button -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button
            class="ml-auto mt-2"
            @click="before_save"
            :disabled="!validateForm"
          >Save Changes</vs-button>
        </div>
      </div>
    </div>
    
  </div>
</template>

<script>
import vSelect from "vue-select";
import "quill/dist/quill.snow.css";
import { quillEditor } from "vue-quill-editor";
import flatPickr from 'vue-flatpickr-component';
import moment from 'moment-timezone'

import moduleAttendeeManagement from "@/store/attendee-management/moduleAttendeeManagement.js";
import moduleExhibitorManagement from "@/store/exhibitor-management/moduleExhibitorManagement.js";
import moduleSponsorManagement from "@/store/sponsor-management/moduleSponsorManagement.js";
import moduleroundtableManagement from "@/store/roundtable-management/moduleRoundtableManagement.js";
import ls from "@/common/localStorage"

let Session_Client_Id = ls.getSessionValueByKey("Session_Client_Id")
let Session_EventStartDate = ls.getSessionValueByKey("Session_EventStartDate")
let Session_EventEndDate = ls.getSessionValueByKey("Session_EventEndDate")
let Session_Event_TZ = ls.getSessionValueByKey("Session_Event_TZ")

var vm;
export default {
  components: {
    vSelect,
    quillEditor,
    "v-select": vSelect,
    flatPickr
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      data_local: JSON.parse(JSON.stringify(this.data)),
      //StartDate: null,
      //EndDate: null,
      configdateTimePickerStart: {
          minDate: new Date(),
          maxDate: null,
          onChange: function(val){
            if(val)
              vm.configdateTimePickerEnd.minDate = new Date(val)
          },
          enableTime: true,
          enableSeconds: false,
          noCalendar: false,
          dateFormat: 'm/d/Y H:i',
          defaultHour: 24,
          defaultMinute: 0,
          time_24hr: true
        }, 
      configdateTimePickerEnd: {        
          minDate: new Date(),
          maxDate: null,
          enableTime: true,
          enableSeconds: false,
          noCalendar: false,
          dateFormat: 'm/d/Y H:i',
          defaultHour: 24,
        defaultMinute: 0,
          time_24hr: true
        },
    };
  },
  computed: {
    
    validateForm() {
      return !this.errors.any();
    },
  },
  methods: {  
    SetTimeByZone : function(strDateTime, timeZone)
    {  
        var date = moment.tz(strDateTime, timeZone).format('MM/DD/YYYY HH:mm');
        return date
    },
  GetTimeByZone : function(strDateTime, timeZone)
    {
      
      strDateTime = moment(strDateTime).format('YYYY-MM-DD HH:mm')
      var strtDate = moment.tz(strDateTime, timeZone);
      strtDate._d.setMinutes(strtDate._d.getMinutes() - strtDate._offset);      
      return strtDate._d;      
    },  
    before_save() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          // if form have no errors
          this.save_changes();
        }
      });
    },
    save_changes() {
      /* eslint-disable */
      console.log(this.data_local)
      if (!this.validateForm) return;

      // Here will go your API call for updating data
      // You can get data in "this.data_local"
      this.data_local.StartDate = this.GetTimeByZone(this.data_local.StartDate, Session_Event_TZ)
      this.data_local.EndDate = this.GetTimeByZone(this.data_local.EndDate, Session_Event_TZ)
      /* eslint-enable */
      this.$vs.loading();
      this.$store
        .dispatch("meetingManagement/saveSettings", {
          settingsData: this.data_local
        })
        .then(res => {
          this.$vs.notify({
            color: "success",
            position: "top-center",
            title: "Settings",
            text: res.message
          });
          this.$vs.loading.close();
        });
       
    },
    reset_data() {
      this.data_local = JSON.parse(JSON.stringify(this.data));
    },

   
  },
  beforeCreate(){
    
  },
  created() {
    vm = this;
    /*if (!moduleMeetingManagement.isRegistered) {
      this.$store.registerModule(
        "meetingManagement",
        moduleMeetingManagement
      );
      moduleMeetingManagement.isRegistered = true;
    }*/
    //this.StartDate= this.data_local.StartDate ? this.SetTimeByZone(this.data_local.StartDate, Session_Event_TZ) : null;
    //this.EndDate= this.data_local.EndDate? this.SetTimeByZone(this.data_local.EndDate, Session_Event_TZ) : null;
    //console.log(this.StartDate)
  },
};
</script>
